import React from 'react';
import Strips_Large_Cart from 'styles/staticAssets/images/Strips_Large_Cart.png';
import cart_header_mobile from 'styles/staticAssets/images/cart_header_mobile.png';
import { CART_PAGE_CONSTANTS } from '../../Constants/CartPageConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
const CartHeaderItem = props => {
  const { isMobile } = props;
  const { CART_HEADER } = CART_PAGE_CONSTANTS;
  return (
    <div className='cart-header' data-testid='cart-header-test'>
      <img src={isMobile ? cart_header_mobile : Strips_Large_Cart} alt=' ' />
      <h1 className='cart-header-text'>{translateWithI18Next(CART_HEADER)}</h1>
    </div>
  );
};

export default CartHeaderItem;
